import React, { useContext } from 'react';
import { Container, Navbar, Nav, Dropdown } from 'react-bootstrap';
import { apiRequest } from '../utils/apiHelper';
import { AppContext } from '../App';


export const MainNavbar = () => {
	const { setPage, expired, link, agents, user, setGetLoad, getExpired, getStaffs,
		getQuickLinks, getQuickReport, getBanner, getAgents, packages, getPackages,
		recentRenew, getRecentRenew, getEnquiries, getLeadStatuses } = useContext(AppContext);
	return (
		<Navbar expand="lg" className="main-nav" >
			<Container fluid>
				<Navbar.Brand className="nav-brand" onClick={() => { setPage('home') }} >SMS</Navbar.Brand>
				<Navbar.Toggle aria-controls="navbarScroll" />
				<Navbar.Collapse id="navbarScroll">
					<Nav className="me-auto my-2 my-lg-0" navbarScroll >
						<Nav.Link onClick={() => {
							setPage('home');
							expired === undefined && getExpired();
							agents === undefined && getAgents();
						}} >Home</Nav.Link>
						<Nav.Link onClick={() => {
							setPage('renew');
							packages === undefined && getPackages();
							getRecentRenew();
						}} >Renew</Nav.Link>
						<Nav.Link onClick={() => {
							setPage('enquiry');
							getEnquiries();
							getLeadStatuses();
						}} >Enquiry</Nav.Link>
						<Nav.Link onClick={() => {
							setPage('agent');
							agents === undefined && getAgents();
						}} >Agent</Nav.Link>
						<Nav.Link onClick={() => {
							setPage('staff');
							getStaffs();
						}} >Staff</Nav.Link>
						<Nav.Link onClick={() => {
							getQuickLinks();
							setPage('quick_links');
						}} >Quick links</Nav.Link>
						<Nav.Link onClick={() => {
							getQuickReport();
							setPage('quick_report');
						}} >Quick Report</Nav.Link>
						<Nav.Link onClick={() => {
							setPage('ads');
							getBanner();
						}} >Ads</Nav.Link>
					</Nav>
					<Dropdown align='end' >
						<Dropdown.Toggle variant="outline-secondary" id="dropdown-menu-align-end" className="menu1" >
							{
								user !== undefined && user.username !== undefined ? user.username : 'Username'
							}
						</Dropdown.Toggle>
						<Dropdown.Menu className="menu-one" >
							<Dropdown.Item eventKey="4" onClick={() => {
								localStorage.clear();
								window.location.reload();
							}} >
								<span className="menu-icon" ><i className="bi bi-box-arrow-left"></i></span>
								<span className="menu-name" >Log out</span>
							</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	)
}